import { ezFadeOut } from 'lib/helpers';

export function ezConfirm(confirmText, confirmCallback, buttonsText = ['Okay', 'Cancel'], optionsArgs) {
  const defaults = {
    confirmHeader: false,
    noticeClass: false,
    modalReplace: false,
    centered: true,
  };
  let options = {};

  if (optionsArgs) {
    options = Object.assign({}, defaults, optionsArgs);
  }

  const confirmHtml = `<div class="ez-modal ez-modal--js ${options.centered ? 'ez-modal--centered' : ''}" id="ez-confirm-modal-container" data-controller="ez-modal">
                        <div class='ez-modal__inner-wrap'>
                          <div id="ez-confirm-modal" class="ez-modal__modal ez-modal__modal--small ${options.noticeClass || ''}">
                            <div class='ez-modal__content' data-target="ez-modal.content">
                              ${options.confirmHeader ? `<h3>${options.confirmHeader}</h3>` : ''}

                              <p>${confirmText}</p>

                              <div class="ez-layout ez-layout--modal-buttons">
                                <button class="ez-btn ez-btn--primary" data-action='ez-modal#confirm'>${buttonsText[0]}</button>
                                <button class="ez-btn ez-btn--tertiary" data-action='ez-modal#deny'>${buttonsText[1]}</button>
                              </div>
                            </div>
                          </div>

                          <div class='ez-dark-overlay' data-action='click->ez-modal#close'></div>
                        </div>
                      </div>`;

  if (options.modalReplace) {
    const activeModal = document.querySelector('.ez-modal.is-active');
    activeModal.parentNode.removeChild(activeModal);
  }
  document.body.insertAdjacentHTML('beforeend', confirmHtml);

  const confirmBtn = document.querySelector('[data-action="ez-modal#confirm"]');
  confirmBtn.addEventListener('ConfirmModalConfirm', confirmCallback);
}

export function ezNotice(noticeText, optionsArgs) {
  const defaults = {
    noticeHeader: false,
    noticeClass: false,
    noticeDuration: false,
    modalReplace: false,
    centered: false,
    reloadAfter: false,
  };
  let options = {};

  if (optionsArgs) {
    options = Object.assign({}, defaults, optionsArgs);
  }

  const reloadFunc = function () {
    window.setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const noticeHtml = `<div class="ez-modal ez-modal--js ${options.centered ? 'ez-modal--centered' : ''}" id="ez-notice-modal-container" data-controller="ez-modal">
                        <div class='ez-modal__inner-wrap'>
                          <div id="ez-notice-modal" class="ez-modal__modal ${options.noticeClass || ''}">
                            <span class="ez-close-btn" data-action="click->ez-modal#close" title="Close"></span>
                            <div class='ez-modal__content' data-target="ez-modal.content">
                              ${options.noticeHeader ? `<h3>${options.noticeHeader}</h3>` : ''}

                              <p>${noticeText}</p>
                            </div>
                          </div>

                          <div class='ez-dark-overlay' data-action='click->ez-modal#close'></div>
                        </div>
                      </div>`;

  if (options.modalReplace) {
    const activeModal = document.querySelector('.ez-modal.is-active');
    activeModal.parentNode.removeChild(activeModal);
  }
  document.body.insertAdjacentHTML('beforeend', noticeHtml);

  if (options.noticeDuration) {
    const noticeModal = document.querySelector('#ez-notice-modal-container');
    const noticeFadeTimer = setTimeout(() => {
      ezFadeOut(noticeModal, 30, () => {
        noticeModal.parentElement.removeChild(noticeModal);
        if (options.reloadAfter) {
          reloadFunc();
        }
      });
    }, options.noticeDuration);

    noticeModal.addEventListener('ModalClosed', function clearNoticeTimeout() {
      clearTimeout(noticeFadeTimer);
      noticeModal.removeEventListener('ModalClosed', clearNoticeTimeout);
      if (options.reloadAfter) {
        reloadFunc();
      }
    });
  }
}
